const getPublicUrl = (path) => path;
// const getPublicUrl = (path) => "/PublicSurveyQA" + path;
export default getPublicUrl;
